import { FC, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import Image from "next/legacy/image";
import { EventPriceDto, getEventPriceRangeString, priceFormatter } from '@sweatpals/shared';
import ImageWrapper from '@/modules/_core/components/images/Image-wrapper';
import moneyBagIcon from '@/public/assets/icons/money-bag-outline.svg';
import { proceBadgeStyles } from './price-badge.styles';
import { Showable, useStyles } from '@sweatpals/react-ui-kit';

export interface PriceBadgeProps {
	isPaid?: boolean;
	isDonationBased?: boolean;
	prices?: EventPriceDto[];
	minDonation?: number;
}

const PriceBadge: FC<PriceBadgeProps> = (props) => {
	const {
		isPaid = false,
		isDonationBased = false,
		prices,
		minDonation,
	} = props;
	const priceString = useMemo(() => getEventPriceRangeString(prices), [prices]);

	const styles = useStyles(proceBadgeStyles);

	return (
		<Box sx={styles.root}>
			<Showable show={!!priceString}>
				<ImageWrapper sx={styles.priceIcon}>
					<Box sx={styles.priceIcon} component={props => <Image src={moneyBagIcon} alt="price" {...props} />} />
				</ImageWrapper>
			</Showable>
			<Typography component="span" sx={styles.priceText}>
				{isPaid ? isDonationBased ? `Donation-based ${minDonation > 0 ? `(min ${priceFormatter(minDonation)})` : ''}` : priceString : 'Free'}
			</Typography>
		</Box>
	);
};

export default PriceBadge;
